module.exports = __webpack_public_path__ + "static/media/bg.a77aa7dd.png";